import { getAxiosInstance } from "../http"

import { Appro } from "../models"

export class CashierService {

    static createTransaction = async (data: any) => {}

    static getTransactionHistory = async () => {}

    static createRequestForAppro = async (id: string, status: string) => { }

    static getRequestsForAppro = async () => {
        
        const axios = getAxiosInstance()

        const response = await axios.get('cashiers/requests-involving-me')

        const result = response.data.map((item: any) => Appro.fromJSON(item))

        return result
    }

    static getDistributorsList = async () => {
        
        const axios = getAxiosInstance()

        const response = await axios.get('cashiers/distributors')

        return response.data
    }

    static getCashiersList = async () => {
        
        const axios = getAxiosInstance()

        const response = await axios.get('cashiers/nearbytills')

        return response.data
    }

    static sendRequestForAppro = async (data: any) => {
        
        const axios = getAxiosInstance()

        const response = await axios.post('cashiers/request-appros', JSON.stringify(data))

        const appro = Appro.fromJSON(response.data)

        console.log(appro)

        return appro
    }


    static acceptRequestForAppro = async (id: number) => {

        const axios = getAxiosInstance()

        const response = await axios.put(`cashiers/accept-request-appros/${id}`)

        const result = Appro.fromJSON(response.data)

        return result
    }

    static rejectRequestForAppro = async (id: number) => {

        const axios = getAxiosInstance()

        const response = await axios.put(`cashiers/reject-request-appros/${id}`)

        const result = Appro.fromJSON(response.data)

        return result
    }

    static confirmRequestAppro = async (id: number) => {

        const axios = getAxiosInstance()

        const response = await axios.put(`cashiers/confirm-request-appros/${id}`)

        const result = Appro.fromJSON(response.data)

        return result
    }


    static getMyTillStatus = async (): Promise<boolean> => {

        const axios = getAxiosInstance()

        const response = await axios.get(`cashiers/is-till-currently-opened`)

        return response.data
    }

    static openMyTill = async ():  Promise<string> => {

        const axios = getAxiosInstance()

        const payload = {"opening_comment": new Date().toISOString()}
        
        const response = await axios.post('cashiers/open-till', JSON.stringify(payload))

        return response.data
    }

    static getMyDailyReports = async(): Promise<any> =>
    {
        const axios = getAxiosInstance()

        const response = await axios.get('cashiers/all-my-reports')

        return response.data

    }
}